// Returns a formatted string for a number in Norwegian currency format
// Eks: 3130000 => "3 130 000 kr"
export function formatCurrency(num?: number): string {
  if (!num) {
    return '0 kr';
  }

  return num.toLocaleString('no-NO', {
    currency: 'NOK',
    style: 'currency',
  }).replace(',00', '');
}
